import queryString from "qs";
import Cookies from "js-cookie";
import config from "../config";
import moment from "moment";
import axios from "axios"
import * as timeago from 'timeago.js';

const cookies = config.cookies;
export function clearCookies() {
    Cookies.remove(cookies.name, { domain: cookies.domain });
    Cookies.remove("ref_url", { domain: cookies.domain });
}
export function setCookies(data) {
    try {
        Cookies.set(cookies.name, {
            token: data.token,
            user: data.user,
            loginType:data.loginType
        }, { expires: cookies.expiry, domain: cookies.domain });
    } catch (e) {
    }
}

//currency formatter
export const USDollar = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });


export function getJsonCookies() {
    let data = Cookies.getJSON(cookies.name);
    if (data) {
        return data.token
    }
}
export function getCookie() {
    let token = Cookies.getJSON(cookies.name);
    if (token) {
        return token
    }
}
export function updateCookie(data) {
    let user = Cookies.getJSON(cookies.name);
    if (data && data.business_name){
        user.business_name = data.business_name;
    }else if(data && data.userData){
        user.user = data.userData
    } 
    Cookies.set(cookies.name, user, { expires: cookies.expiry });
}
export function phoneNumberFormat(item) {
        if (!item) {
            return '';
        }
        var value = item.toString().trim().replace(/^\+/, '');
        if (value.match(/[^0-9]/)) {
            return item;
        }
        var city, number;
        switch (value.length) {
            case 1:
            case 2:
            case 3:
                city = value;
                break;
            default:
                city = value.slice(0, 3);
                number = value.slice(3);
        }
        if (number) {
            let num=""
            if (number.length > 3) {
                num = number.slice(0, 3) + '-' + number.slice(3, 7);
            } else {
                num = number;
            }
            return ("(" + city + ") " + num).trim();
        } else {
            return "(" + city;
        }

}
export function emailValidation(email) {
    const emailRegx = /^([A-Za-z0-9_\-.+])+@([A-Za-z0-9_\-.+])+\.([A-Za-z]{2,4})$/   
    if (email.length) {
        let res = email.match(emailRegx)
        if (res) {
            return true
        }
    }
    return false
}
export function phoneNumberValidation(phone){
    const phoneRegx = /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/im
    if (phone.length) {
        let res = phone.match(phoneRegx)
        if (res) {
            return true
        }
    }
    return false
}

export const objToUrlParams = obj => {
    return queryString.stringify(cleanObject(obj));
  };
export function cleanObject(obj) {
    for (var propName in obj) {
      if (obj[propName] === null || obj[propName] === undefined) {
        delete obj[propName];
      }
    }
    return obj;
  }
export function formatPhoneNumber(phoneNumberString) {
    var cleaned = ('' + phoneNumberString).replace(/\D/g, '')
    var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
    if (match) {
      var intlCode = (match[1] ? '+1 ' : '')
      return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('')
    }
    return phoneNumberString
  }
export function expiryMask(item) {
    if (!item) {
        return '';
    }
    var value = item.toString().trim().replace(/[^0-9]+/g, '');
    if (value.match(/[^0-9]/)) {
        return item;
    }
    var mm, yy;
    switch (value.length) {
        case 1:
        case 2:
            if(parseFloat(value)>12){
                mm = "12";
            }else{
                mm = value;
            }
            break;
        default:
            if(parseFloat(value.slice(0, 2)>12)){
                    mm = "12";
            }else{
                mm = value.slice(0, 2);
            }
            yy = value.slice(2);
    }
    if (yy) {
        return (mm + "/" + yy).trim();
    } else {
        return mm;
    }
}
export function checkDueDate(data) {
    
    if(data && (data.invoice_source ==="app" || data.invoice_source ==="invoice")){
        if(data && data.invoice_due){
            let dueDate = new Date(data.invoice_due)
            let today = new Date()
            if (today < dueDate) {
                return `Due on ${moment(data.invoice_due.slice(0,10)).format('LL')}`
            } else if (today.getDate() === dueDate.getDate()) {
                //  due today
                return `Outstanding`
            }
            else if (today > dueDate) {
                //  due past date
                return `Overdue ${timeago.format(dueDate, 'us').replace("ago","")}`
            }
            else {
                return `Due on  ${moment(data.invoice_due.slice(0,10)).format('LL')}`
            } 
        }else{
            return "Outstanding"
        }
    }else if(data && data.invoice_source ==="getpaid"){
        if(data && data.invoice_due){
            let dueDate = new Date(data.invoice_due)
            let today = new Date()
            if (today.getDate() === dueDate.getDate()) {
                return `Outstanding`
            }else if (today > dueDate) {
                 return `Unpaid ${timeago.format(dueDate, 'us').replace("ago","")}`
            }  
        }else{
            return "Outstanding"
        }
    }
    return "Outstanding"
}
export function textCapitalize(word) {
    if (typeof word !== 'string') return word
    return word.charAt(0).toUpperCase() + word.slice(1)
}
export function getSegmentUser(){
    let data = Cookies.getJSON("guestUser");
    if (data) {
        return data.userId
    }else{
        return false
    }
}
export function setSegmentUser(){
    let id= Math.floor(Math.random() * Math.floor(Math.random() * Date.now()))
    try {
        Cookies.set("guestUser", {
            userId:id
        }, { expires: cookies.expiry, domain: cookies.domain });
        return id;
    } catch (e) {
    }
}
export function getReferrer() {
    let data = Cookies.getJSON("ref_url");
    if (data && data.ref_url) {
        return data.ref_url
    } else {
        return false
    }
}
export function setReferrer(url) {
    try {
        Cookies.set("ref_url", {
            ref_url: url
        }, { expires: cookies.expiry, domain: cookies.domain });
    } catch (e) {
    }
}
export function cardYearValidation(value) {
    if (value) {
        let mm = value.substring(0, 2)
        let yy = value.substring(2)

        let year = new Date().getFullYear().toString().slice(2)
        let month = new Date().getMonth() + 1

        let cardyear = parseFloat(yy)
        let cardmonth = parseFloat(mm)

        let max = parseFloat(year) + 15
        
        if ( ((cardmonth >= month && cardyear === parseFloat(year)) ||  (cardyear !== parseFloat(year) && cardmonth <=12)) && (cardyear <= max && cardyear >= parseFloat(year))) {
            return true
        }
        else {
            return false
        }
    }
    return false
}
export function isPaymentOverDue(data) {
    
    if(data && (data.invoice_source ==="app" || data.invoice_source ==="invoice") ){
        if(data && data.invoice_due){
            let dueDate = new Date(data.invoice_due)
            let today = new Date()
            if (today > dueDate) {
                //  due past date
                return true
            }
            else {
                return false
            } 
        }else{
            return false
        }
    }else if(data && data.invoice_source ==="getpaid"){
        if(data && data.invoice_due){
            let dueDate = new Date(data.invoice_due)
            let today = new Date()
            if (today > dueDate) {
                return true
            }  
        }else{
            return false
        }
    }
    return false
}
export function downloadFile(fileUrl,name){
    axios({
        url:fileUrl ,
        method: 'GET',
        responseType: 'blob', 
        'x-access-token':""
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${name}.pdf`);
        document.body.appendChild(link);
        link.click();
      });
}
export function priceFormat(price){
    const formatter = new Intl.NumberFormat('en-US',{
        minimumFractionDigits: 2,
      });
    if(price){
       return formatter.format(price)
    }
}
export function nFormatter(number, precision = 2) {
    const abbrev = ["", "K", "M", "B", "T"];
    const unrangifiedOrder = Math.floor(Math.log10(Math.abs(number)) / 3)
    const order = Math.max(0, Math.min(unrangifiedOrder, abbrev.length -1 ))
    const suffix = abbrev[order];
  
    return (number / Math.pow(10, order * 3)).toFixed(precision) + suffix;
}
export function setpaymentAttempt() {
    let data = Cookies.getJSON("userPayment") || { count:0, updatedTime: "" }
    if(data){
        data = { ...data,...updateTimeAndCount(data.count) }
    }
    Cookies.set("userPayment", JSON.stringify(data), { expires: 1 });
}
export function getPaymentCount() {
    let isAutomation = Cookies.getJSON('isAutomation')
    console.log("isAutomation = "+isAutomation);
    if(!isAutomation)
    {
        let initial = { count:0, updatedTime: "" }
        let data = Cookies.getJSON("userPayment") || initial
        if(data.updatedTime){
            let diff = getTimeDifferenceInHours(data.updatedTime)
            if (Math.abs(Math.round(diff)) >= 5) {
            data = {...data,...initial}
            Cookies.set("userPayment", JSON.stringify(data), { expires: 1 });
            }
        }
        return data.count
    } else {
        return 0
    }
}
function updateTimeAndCount(count) {
    return {
      updatedTime:new Date(),
      count: count + 1
    }
}
function getTimeDifferenceInHours(time) {
    let diff = (new Date().getTime() - new Date(time).getTime()) / 1000;
    diff /= (60);
    return diff
}
